import { Feature } from '../features';
import { RuleType } from '../rules';
import { SubFeature } from './subfeatures';

interface RulesetRuleOptions {
  mandatory?: RuleType[];
  optional?: RuleType[];
}

type OptionsType = { [feature in Feature]: { [subFeature in SubFeature]?: RulesetRuleOptions } };

const Options: OptionsType = {
  'Cart Abandonment': {
    REMINDER: {
      mandatory: ['.CartAbandonment'],
    },
  },
  'Browse Abandonment': {
    REMINDER: {
      mandatory: ['.BrowseAbandonment'],
    },
  },
  'Marketing Permission': {
    EMAIL_OPT_IN: {
      mandatory: ['.NoActiveMarketingPermission'],
      optional: [
        '.ExcludeEmailSource',
        '.IncludeEmailSource',
        '.ImpressionPathWhitelist',
        '.Geolocation',
        '.DeviceType',
        '.UserLoggedIn',
      ],
    },
    EMAIL_CONFIRMED_OPT_IN: {
      mandatory: ['.NoActiveMarketingPermission'],
      optional: [
        '.ExcludeEmailSource',
        '.IncludeEmailSource',
        '.ImpressionPathWhitelist',
        '.Geolocation',
        '.DeviceType',
        '.UserLoggedIn',
      ],
    },
    SMS_OPT_IN: {
      mandatory: ['.NoActiveSMSMarketingPermission'],
      optional: ['.ImpressionPathWhitelist', '.Geolocation', '.DeviceType', '.UserLoggedIn'],
    },
    EMAIL_OPT_OUT: {
      mandatory: ['.NoActiveMarketingPermission'],
      optional: [
        '.ExcludeEmailSource',
        '.IncludeEmailSource',
        '.ImpressionPathWhitelist',
        '.Geolocation',
        '.DeviceType',
        '.UserLoggedIn',
      ],
    },
    SMS_OPT_OUT: {
      mandatory: ['.NoActiveSMSMarketingPermission'],
      optional: ['.ImpressionPathWhitelist', '.Geolocation', '.DeviceType', '.UserLoggedIn'],
    },
  },
  TestFeature1: {},
  TestFeature2: {},
};

export const getMandatoryRuleTypes = (feature: Feature, subFeature: SubFeature): RuleType[] =>
  (Options[feature][subFeature] && Options[feature][subFeature].mandatory) || [];

export const getOptionalRuleTypes = (feature: Feature, subFeature: SubFeature): RuleType[] =>
  (Options[feature][subFeature] && Options[feature][subFeature].optional) || [];

export const isMandatory = (feature: Feature, subFeature: SubFeature, ruleType: RuleType): boolean =>
  Options[feature][subFeature] &&
  Options[feature][subFeature].mandatory &&
  Options[feature][subFeature].mandatory.indexOf(ruleType) > -1;
